"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _hooks = require("../hooks");

var _this = void 0;

var GlobalErrorHandler = function GlobalErrorHandler(_ref) {
  var error = _ref.error;
  var code = error && (error.code || error.status);
  var message = error && (error.data && _this.state.error.data.message || error.message);

  var _useClassNames = (0, _hooks.useClassNames)({
    alias: 'ErrorHandler'
  }),
      classNames = _useClassNames.classNames;

  return /*#__PURE__*/_react.default.createElement("div", {
    className: classNames()
  }, /*#__PURE__*/_react.default.createElement("h1", {
    className: classNames('code')
  }, code), /*#__PURE__*/_react.default.createElement("p", {
    className: classNames('message')
  }, message));
};

GlobalErrorHandler.propTypes = {
  error: _propTypes.default.shape({
    code: _propTypes.default.number,
    status: _propTypes.default.number,
    message: _propTypes.default.string,
    data: _propTypes.default.shape({
      message: _propTypes.default.string
    })
  })
};
var _default = GlobalErrorHandler;
exports.default = _default;